import { apiService } from '.';
import { IRegisterBlockPages } from '../shared/types/blockPages';

export const asyncPostBlockPage = async (
    formBlockPages: IRegisterBlockPages
) => {
    return await apiService.post('/api/blockPages', formBlockPages);
};

export const asyncGetBlockPages = async (page?: number, pageSize?: number) => {
    return await apiService.get('/api/blockPages', {
        limit: pageSize || '',
        page: page || '',
    });
};

export const asyncDeleteBlockPage = async (id: string) => {
    return await apiService.delete(`/api/blockPages/${id}`);
};

export const asyncGetBlockPageId = async (id: string | undefined) => {
    return await apiService.get(`/api/blockPages/${id}`);
};

export const asyncPatchtBlockPage = async (
    id: string,
    formBlockPages: IRegisterBlockPages
) => {
    return await apiService.put(`/api/blockPages/${id}`, formBlockPages);
};
